import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { cn, getKey } from "pax-ui/core";

/**
 * Set the breakpoint of when each text is rendered
 */
type ResponsiveTextVariant = "md" | "lg" | "sm";

@Component({
  selector: "pax-responsive-text",
  standalone: true,
  templateUrl: "./responsive-text.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsiveText implements OnChanges {
  @Input({ required: true }) text!: string;
  @Input({ required: true }) mobileText!: string;
  @Input({ required: true }) variant!: ResponsiveTextVariant;

  protected textStyle!: string;
  protected mobileTextStyle!: string;

  ngOnChanges(changes: SimpleChanges): void {
    const newVariant = changes[getKey<ResponsiveText>("variant")];
    if (newVariant) {
      this.textStyle = this.getTextStyle();
      this.mobileTextStyle = this.getMobileTextStyle();
    }
  }

  private getTextStyle() {
    return cn(
      "sr-only",
      this.variant === "lg" && "lg:not-sr-only",
      this.variant === "md" && "md:not-sr-only",
      this.variant === "sm" && "sm:not-sr-only",
    );
  }

  private getMobileTextStyle() {
    return cn(
      this.variant === "lg" && "lg:hidden",
      this.variant === "md" && "md:hidden",
      this.variant === "sm" && "sm:hidden",
    );
  }
}
